/* ==========================================================================
   ANASA – Interaktionen
   Wishlist (localStorage), Navbar-Scroll, Mobile-Menü, Loader, Quick-Add.
   Nutzt Dawns globale routes/cart-drawer für einen echten Warenkorb.
   ========================================================================== */
(function () {
  'use strict';

  var WISHLIST_KEY = 'anasa_wishlist';

  /* ---------- Wishlist ---------------------------------------------------- */
  var Wishlist = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
      catch (e) { return []; }
    },
    save: function (list) {
      try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    },
    has: function (id) { return this.get().indexOf(id) !== -1; },
    toggle: function (id) {
      var list = this.get();
      var i = list.indexOf(id);
      if (i === -1) list.push(id); else list.splice(i, 1);
      this.save(list);
      return i === -1; // true = jetzt aktiv
    }
  };

  function updateWishlistBadge() {
    var badge = document.getElementById('anasa-wishlist-count');
    if (!badge) return;
    var n = Wishlist.get().length;
    badge.textContent = n;
    badge.classList.toggle('is-visible', n > 0);
  }

  function syncHearts() {
    var active = Wishlist.get();
    document.querySelectorAll('[data-wishlist-id]').forEach(function (btn) {
      var on = active.indexOf(btn.getAttribute('data-wishlist-id')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function bindHearts() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-id]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-wishlist-id');
      var nowOn = Wishlist.toggle(id);
      btn.setAttribute('aria-pressed', nowOn ? 'true' : 'false');
      var svg = btn.querySelector('svg');
      if (svg) { svg.classList.remove('ae-heart-beat'); void svg.offsetWidth; svg.classList.add('ae-heart-beat'); }
      updateWishlistBadge();
      // Auf allen gleichen Karten spiegeln (z.B. Produktseite + Grid)
      document.querySelectorAll('[data-wishlist-id="' + id.replace(/"/g, '\\"') + '"]').forEach(function (b) {
        b.setAttribute('aria-pressed', nowOn ? 'true' : 'false');
      });
      renderWishlistPage();
    });
  }

  /* Wishlist-Seite: alle Karten sind vorgerendert, wir zeigen nur gemerkte. */
  function renderWishlistPage() {
    var wrap = document.getElementById('anasa-wishlist-grid');
    if (!wrap) return;
    var active = Wishlist.get();
    var shown = 0;
    wrap.querySelectorAll('[data-card-id]').forEach(function (card) {
      var on = active.indexOf(card.getAttribute('data-card-id')) !== -1;
      card.classList.toggle('is-shown', on);
      if (on) shown++;
    });
    wrap.classList.add('is-ready');
    var empty = document.getElementById('anasa-wishlist-empty');
    if (empty) empty.style.display = shown === 0 ? 'block' : 'none';
  }

  /* ---------- Navbar / Scroll -------------------------------------------- */
  function initHeader() {
    var header = document.querySelector('.anasa-header');
    if (!header || header.dataset.transparent !== 'true') return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 50); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile-Menü ------------------------------------------------- */
  function initMobileMenu() {
    var menu = document.getElementById('anasa-mobile');
    if (!menu) return;
    function open() { menu.classList.add('is-open'); document.body.classList.add('anasa-no-scroll'); }
    function close() { menu.classList.remove('is-open'); document.body.classList.remove('anasa-no-scroll'); }
    document.querySelectorAll('[data-mobile-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-mobile-close]').forEach(function (b) { b.addEventListener('click', close); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
  }

  /* ---------- Loader ------------------------------------------------------ */
  function initLoader() {
    var loader = document.getElementById('anasa-loader');
    if (!loader) return;
    var hide = function () { loader.classList.add('is-hidden'); };
    if (document.readyState === 'complete') { setTimeout(hide, 300); }
    else { window.addEventListener('load', function () { setTimeout(hide, 300); }); }
    // Sicherheitsnetz
    setTimeout(hide, 2500);
  }

  /* ---------- Quick-Add (In den Korb) ------------------------------------ */
  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
  }

  function quickAdd(variantId, button) {
    var cart = document.querySelector('cart-drawer');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      formData.append('sections_url', window.location.pathname);
    }
    var original = button ? button.textContent : '';
    if (button) { button.textContent = '…'; button.disabled = true; }

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) { // Fehler (z.B. ausverkauft)
          if (button) button.textContent = 'Nicht verfügbar';
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (button) button.textContent = original;
      })
      .catch(function () {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .finally(function () {
        if (button) { setTimeout(function () { button.textContent = original; button.disabled = false; }, 400); }
      });
  }

  function bindQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-quick-add');
      if (id) quickAdd(id, btn);
    });
  }

  /* ---------- Init -------------------------------------------------------- */
  function init() {
    updateWishlistBadge();
    syncHearts();
    bindHearts();
    bindQuickAdd();
    initHeader();
    initMobileMenu();
    initLoader();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Bei Shopify-Theme-Editor-Neuladen von Sections erneut synchronisieren
  document.addEventListener('shopify:section:load', function () {
    updateWishlistBadge(); syncHearts(); initHeader(); initMobileMenu();
  });

  window.AnasaWishlist = Wishlist;
})();
